// frontend/src/components/TypographyTab.js

function TypographyTab({ config, onChange }) {
  const updateFont = (key, value) => {
    const next = JSON.parse(JSON.stringify(config));
    next.typography[key] = value;
    onChange(next);
  };

  return (
    <div className="leadline-border overflow-hidden bg-[#F5EDE0]">
      <div className="px-4 py-2 text-sm font-medium text-white" style={{ backgroundColor: config.colors.secondary }}>
        Typography
      </div>
      <div className="p-4 space-y-3">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
          <label className="block">
            <span className="block text-xs mb-1 text-[#3A3530]">Heading Font</span>
            <input
              value={config.typography.headingFont}
              onChange={(e) => updateFont("headingFont", e.target.value)}
              className="w-full leadline-border-thin px-2 py-1 bg-white text-sm"
            />
          </label>
          <label className="block">
            <span className="block text-xs mb-1 text-[#3A3530]">Body Font</span>
            <input
              value={config.typography.bodyFont}
              onChange={(e) => updateFont("bodyFont", e.target.value)}
              className="w-full leadline-border-thin px-2 py-1 bg-white text-sm"
            />
          </label>
        </div>
        <div className="leadline-border-thin p-4 bg-white">
          <h3 className="text-xl mb-2" style={{ fontFamily: config.typography.headingFont }}>
            {config.content.hero.headline}
          </h3>
          <p className="text-sm" style={{ fontFamily: config.typography.bodyFont }}>
            {config.content.hero.tagline}
          </p>
        </div>
      </div>
    </div>
  );
}

export default TypographyTab;
